<script setup>
import {onMounted, ref} from "vue";
import Grid from "../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";
import {ucFirst} from "../../../../frontend/src/helpers/string";
import FoundStartupsModal from "@/views/needs/FoundStartupsModal.vue";

const {items, gridParams, gridMethods} = useGrid(getList);

const columns = [
    {
        label: 'ID',
        name: 'id',
    },
    {
        label: 'Name',
        name: 'name',
    },
    {
        label: 'Description',
        name: 'description',
    },
    {
        label: 'Enterprise',
        name: 'enterprise_name',
    },
    {
        label: 'Created by',
        name: 'user_email',
    },
    {
        label: 'Created At',
        name: 'created_at',
    },
    {
        label: 'Share Type',
        name: 'ecosystems_share_type',
    },
    {
        label: 'Public Status',
        name: 'public_status',
    },
    {
        label: 'Status',
        name: 'status',
    },
    {
        label: 'Added by AI',
        name: 'ai_count',
        component: 'Link',
    },
    {
        label: 'Matched Startups',
        name: 'matched_count',
        component: 'Link',
    },
    {
        label: 'Submitted Startups',
        name: 'submitted_count',
        component: 'Link',
    },
    {
        label: 'Liked',
        name: 'liked_count',
    },
    {
        label: 'Disliked',
        name: 'disliked_count',
    },
];

const id = ref(0);
const listType = ref(null);
const showModal = ref(false);
const startupsModal = ref(null)

onMounted(() => {
    gridMethods.setColumns(columns);
});

function getList(params) {
    return needsService.getEcosystemNeeds(id.value, listType.value, params);
}

function action(params) {
    if (params.action === 'show_matched_startups') {
        startupsModal.value.open(params.rowId, 'matched');
    } else if (params.action === 'show_ai_startups') {
        startupsModal.value.open(params.rowId, 'ai_matched');
    } else if (params.action === 'show_submitted_startups') {
        startupsModal.value.open(params.rowId, 'submitted');
    }
}

function open(ecosystemId, type) {
    id.value = ecosystemId;
    listType.value = type;

    gridMethods.resetList();
    showModal.value = true;
}

defineExpose({
    open
});

</script>

<template>
    <div>
        <b-modal v-model="showModal" :title="`${ucFirst(listType)} needs`" hide-footer modal-class="modal-w-xxxl">
            <div class="main-table-wrapper">
                <div class="main-table overflow-auto">
                    <Grid
                        :columns="columns"
                        :data="items"
                        :page-length="parseInt(gridParams.pageLength)"
                        :total-rows-count="gridParams.totalRowsCount"
                        :currentPage="gridParams.currentPage"
                        class="mb-3"
                        @changePage="gridMethods.changePage"
                        @action="action"
                    />
                </div>
            </div>
        </b-modal>

        <FoundStartupsModal
            ref="startupsModal"
            :ecosystemId="id"
        />
    </div>
</template>

<style scoped>

</style>
